<template>
  <div class="post_warp">
    <template v-if="shopStep && once == 'false'">
      <step1 v-if="step == 1" />
      <step2 v-if="step == 2" />
      <step3 v-if="step == 3" />
      <step4 v-if="step == 4" />
      <step5 v-if="step == 5" />
      <step6 v-if="step == 6" />
    </template>
  </div>
</template>

<script>
import step1 from '@/components/post/step1';
import step2 from '@/components/post/step2';
import step3 from '@/components/post/step3';
import step4 from '@/components/post/step4';
import step5 from '@/components/post/step5';
import step6 from '@/components/post/step6';
import lang from './../../common/language/post';
import { mapState, mapMutations } from 'vuex';
import { Dialog } from 'vant';
export default {
  data() {
    return {
      shopStep: false, //字典请求
      topTitle: '',
      lang: lang,
      userInfo: [], //用户信息
      propertyUser: [], //楼盘用户信息
      proInfo: [], //楼盘信息
      once: '' // 标识符 session 判断是否是第一次进入页面
      // height: '',
      // : document.body.scrollHeight
    };
  },
  created() {
    // this.height = window.innerHeight;
    this.getDictionary();
    this.once = sessionStorage.getItem('once');
    if (sessionStorage.getItem('once') == null) {
      sessionStorage.setItem('once', true);
      // 刊登刷新回到step1
      if (this.$route.query.hasOwnProperty('type') == false) {
        this.$router.push({
          name: 'step1',
          query: { fromapp: this.$route.query.fromapp, version: this.$route.query.version }
        });
      }
    }
    this.topTitle = this.getTitle();
    if (this.$route.name.indexOf('step') > -1) {
      this.stepChange(this.$route.name.substr(this.$route.name.length - 1, 1));
    }
  },
  // mounted () {
  //   // 键盘弹出隐藏固定定位上下步
  //   var _this = this
  //   window.addEventListener('resize', function (params) {
  //     if (window.innerHeight < _this.height) {
  //       _this.setBtn(false)
  //     } else {
  //       _this.setBtn(true)
  //     }
  //   })
  // },
  computed: {
    ...mapState(['stepActive', 'propertyInfo', 'propertyUserInfo']),
    step() {
      return this.$store.state.stepActive;
    }
  },
  methods: {
    ...mapMutations([
      'setdictionary',
      'setUserData',
      'setProperty',
      'stepChange',
      'clearAll'
      // "setBtn",
    ]),
    getDictionary() {
      this.pub.getDictionary().then(e => {
        this.setdictionary(e);
        this.shopStep = true;
      });
    },
    //获取个人信息 + 获取单个房源信息
    getInfo() {
      let propertyUser = this.axios.get(this.pub.getApi().GetPropertyUserInfoFullById, { params: { propertyId: this.$route.query.id } }).then(res => {
        if (res.data.code === 0 && res.data.result) {
          this.propertyUser = res.data.result[0];
          this.setUserData({ ...this.propertyUser });
        }
      });

      let propertyInfo = this.axios.get(this.pub.getApi().GetPropertyFullById, { params: { propertyId: this.$route.query.id } }).then(res => {
        if (res.data.code === 0 && res.data.result) {
          this.proInfo = res.data.result;
          for (let k in this.proInfo) {
            if (k === 'beginRentTime') {
              this.proInfo[k] = this.proInfo[k] * 1000;
            }
            if (k === 'salePrice') {
              this.proInfo[k] = parseInt(this.proInfo[k] / 10000);
            }
            if (k === 'isVerifyArea') {
              this.proInfo[k] = !this.proInfo[k];
            }
            if (k === 'estateAddressWithCulture') {
              this.proInfo.estateAddress = this.proInfo[k];
              this.proInfo.estateAddressEN = this.proInfo[k];
            }
          }
          this.setProperty({ ...this.proInfo });
        }
      });

      let userInfo = this.axios.get(this.pub.getApi().GetUserInfo).then(res => {
        this.userInfo = res.data.result;
      });

      Promise.all([propertyUser, propertyInfo, userInfo])
        .then(result => {
          if (this.userInfo.isPropertyAgent && this.propertyInfo.propertySource == 1) {
            const data = {
              companyNameCN: this.userInfo.companyNameCN,
              companyNameEN: this.userInfo.companyNameEN,
              companyTel: this.userInfo.companyTelephone,
              companyAddress: this.userInfo.companyAddress,
              companyLicenceNumber: this.userInfo.companyLicense,
              agentLicenceNumber: this.userInfo.license,
              customerTel: '',
              propertySource: 2
            };
            this.setProperty({ ...data });
            this.setUserData({ ...data });
          } else if (this.propertyInfo.propertySource == 2) {
            this.setUserData({ agentCardPath: this.userInfo.agentCardPath }); // 获取当前用户代理证
          }
          sessionStorage.setItem('once', false);
          this.once = sessionStorage.getItem('once');
        })
        .catch(err => {
          sessionStorage.setItem('once', false);
          this.once = sessionStorage.getItem('once');
          if (document.URL.indexOf('en-us') > -1) {
            location.href = `/en-us/404/`;
          } else if (document.URL.indexOf('zh-cn') > -1) {
            location.href = `/zh-cn/404/`;
          } else {
            location.href = `/404/`;
          }
        });
    },
    // 获取单个房源信息 (续费||支付使用)
    getProperty() {
      this.axios
        .get(this.pub.getApi().GetPropertyFullById, {
          params: { propertyId: this.$route.query.id }
        })
        .then(res => {
          if (res.data.code === 0 && res.data.result) {
            this.proInfo = res.data.result;
            // 设置楼盘属性前 坐的处理 1. 时间*1000 2. saleprice /10000 3.面积审核取反
            for (let k in this.proInfo) {
              if (k === 'beginRentTime') {
                this.proInfo[k] = this.proInfo[k] * 1000;
              }
              if (k === 'salePrice') {
                this.proInfo[k] = parseInt(this.proInfo[k] / 10000);
              }
              if (k === 'isVerifyArea') {
                this.proInfo[k] = !this.proInfo[k];
              }
              if (k === 'estateAddressWithCulture') {
                this.proInfo.estateAddress = this.proInfo[k];
              }
            }
            this.setProperty({ ...this.proInfo });
            sessionStorage.setItem('once', false);
            this.once = sessionStorage.getItem('once');
          }
        });
    },
    // 判断是否需要获取信息
    needPropertyData() {
      if (sessionStorage.getItem('once') == 'true') {
        this.getInfo();
      }
    },
    getTitle() {
      if (JSON.stringify(this.$route.query) && this.$route.query.hasOwnProperty('type') == false) {
        if (sessionStorage.getItem('once') == 'true') {
          this.clearAll();
          this.axios.get(this.pub.getApi().GetUserInfo).then(res => {
            if (res.data.code == 0 && res.data.result) {
              let userInfo = res.data.result;
              // 管理后台停用当前代理
              if (userInfo.isAllowPublishProperty === false) {
                this.$dialog({ title: lang.stop, confirmButtonText: lang.confirm }).then(() => this.$router.push('/'));
              }
              if (userInfo.isPropertyAgent) {
                const data = {
                  userID: userInfo.userID,
                  contactNameCN: userInfo.nickName,
                  email: userInfo.email,
                  telphone: userInfo.telephone,
                  companyNameCN: userInfo.companyNameCN,
                  companyNameEN: userInfo.companyNameEN,
                  companyTel: userInfo.companyTelephone,
                  companyAddress: userInfo.companyAddress,
                  companyLicenceNumber: userInfo.companyLicense,
                  agentLicenceNumber: userInfo.license,
                  propertySource: 2,
                  agentCardPath: userInfo.agentCardPath /*代理证图片*/,
                  // agentCardPath: 'https://www.baidu.com/img/bd_logo1.png?where=super',
                  customerTel: ''
                };
                this.clearAll();
                this.setUserData({ ...data });
                sessionStorage.setItem('once', false);
                this.once = sessionStorage.getItem('once');
              } else {
                const data = {
                  userID: userInfo.userID,
                  contactNameCN: userInfo.nickName,
                  email: userInfo.email,
                  telphone: userInfo.telephone,
                  propertySource: 1
                };
                this.clearAll();
                this.setUserData({ ...data });
                sessionStorage.setItem('once', false);
                this.once = sessionStorage.getItem('once');
              }
            }
          });
        }
        return lang.toptitle;
      } else if (this.$route.query.type == 'edit') {
        if (sessionStorage.getItem('once') == 'true') {
          this.needPropertyData();
          this.stepChange(1);
        }
        if (this.propertyInfo.propertyID && this.$route.query.id != this.propertyInfo.propertyID) {
          this.getInfo();
        }
        return lang.edittitle + '(' + this.$route.query.id + ')';
      } else if (this.$route.query.type == 'copy') {
        if (sessionStorage.getItem('once') == 'true') {
          this.needPropertyData();
          this.stepChange(1);
        }
        if (this.propertyInfo.propertyID && this.$route.query.id != this.propertyInfo.propertyID) {
          this.getInfo();
        }
        return lang.copytitle;
      } else if (this.$route.path.indexOf('pay') > -1 && this.$route.query.type == 1) {
        if (sessionStorage.getItem('once') == 'true') {
          this.getProperty();
          this.stepChange(6);
          return lang.paytitle;
        }
      } else if (this.$route.path.indexOf('pay') > -1 && this.$route.query.type == 2) {
        if (sessionStorage.getItem('once') == 'true') {
          this.getProperty();
          this.stepChange(6);
          return lang.addSuntitle;
        }
      }
    }
  },
  watch: {
    $route(to, from) {
      if (to.name.indexOf('step') > -1) {
        this.stepChange(to.name.substr(to.name.length - 1, 1));
      }
    }
  },
  beforeRouteEnter(to, from, next) {
    if (from.path == '/') {
      localStorage.removeItem('vuex');
      sessionStorage.removeItem('once');
      next();
    } else {
      next();
    }
  },
  components: {
    step1,
    step2,
    step3,
    step4,
    step5,
    step6,
    [Dialog.name]: Dialog
  },
  metaInfo() {
    return {
      title: this.topTitle
    };
  },
  destroyed() {
    Dialog.close();
  }
};
</script>

<style lang="scss" scoped>
.post_warp {
  text-align: left;
  font-family: 'PingFangSC-Regular';
  background-color: #f5f6f7;
  height: 100%;
  overflow-y: scroll;
  box-sizing: border-box;
  padding-bottom: 64px;
}
.van-dialog__message--has-title {
  font-size: 15px;
  color: #333;
}
// .van-toast--default {
//   width: 110px !important;
// }
// tit 标题样式
.tit {
  height: 45px;
  line-height: 45px;
  margin: 15px 0 5px 0;
  .num {
    width: 32px;
    height: 25px;
    background-color: #28252f;
    margin-right: 10px;
    color: #fff;
    display: inline-block;
    text-align: center;
    line-height: 25px;
  }
  .titname {
    font-size: 15px;
    color: #333333;
    font-weight: 600;
  }
}
.van-nav-bar__text {
  font-size: 16px;
}
/deep/ .van-field__label {
  max-width: 120px;
}
// 按钮 next样式
.next {
  position: fixed;
  bottom: 0;
  left: 0;
  background-color: #001a33;
  width: 100%;
  height: 64px;
  display: flex;
  justify-content: space-around;
  align-items: center;
  z-index: 999;
  .nextBtn {
    width: 40%;
    background: #031932;
    color: #fff;
  }
}
// 对话框
.van-dialog__confirm .van-button__text {
  font-weight: 600;
}
.van-dialog__header {
  font-weight: 600 !important;
}
/deep/ .van-dialog__header {
  font-weight: 600;
}
</style>
